
export class DeletePortfolioRequest{
    public userId!:string;
    public businessId!:string;
    public portfolioId!:number;
}